/* DEVELOPER NOTE:
	Migration port-forward (Select2 -> pict-section-picker): the "EntitySelectorMultiple" input type now renders via the
	"Picker" stack across ALL themes. EDIT attaches the Picker provider; READ / PRINT attach PickerDisplay.
	Every theme includes the matching Picker template by reference, so there is a single source of the
	picker markup. The field keeps InputType "EntitySelectorMultiple" in the manifest -- no manifest edit is needed;
	the broker maps its Entity descriptor and infers multi-select from the InputType name;
	PickerDisplay resolves the entity names (+ EntityTag badges) for the Read/Print display.
*/

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker -->
				{~T:PictProvider-Theme-Edit-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Edit-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* READ THEME - forwarded to the Picker display: PickerDisplay resolves the value into the shared
	   PICKER-DISPLAY node the Picker's own Read templates render. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Read-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Read-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
	/* PRINT THEME - forwarded to the Picker display (see READ). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-Template-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-VerticalTemplate-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- Provided InputType: EntitySelectorMultiple; Applied InputType: Picker (display) -->
				{~T:PictProvider-Theme-Print-TabularTemplate-Begin-Input-InputType-Picker~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-EntitySelectorMultiple',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				{~T:PictProvider-Theme-Print-TabularTemplate-End-Input-InputType-Picker~}`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
